import { module } from 'angular';
import { react2angular } from 'react2angular';

import { TemplatePlanErrors } from 'core/pipeline/config/templates/TemplatePlanErrors';

export const TEMPLATE_PLAN_ERRORS = 'spinnaker.core.templatePlanErrors.component';
module(TEMPLATE_PLAN_ERRORS, [])
  .component('templatePlanErrors', react2angular(TemplatePlanErrors, ['errors']));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/pipeline/config/templates/templatePlanErrors.component.ts